import { Box, Typography, makeStyles } from '@material-ui/core';
import { CSSProperties, ReactNode } from 'react';
import { WbButton } from '../../WbButton';

type FilterGroupProps = {
  style?: CSSProperties;
  label: ReactNode;
  hideShowMore?: boolean;
  onShowMore?: () => void;
  children: ReactNode;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        gap: theme.spacing(0.5),
      },
    },
    label: {
      fontWeight: 700,
      color: theme.palette.secondary.dark,
      textTransform: 'uppercase',
    },
    filters: {},
  }),
  { name: 'FilterGroup' },
);

export const FilterGroup = ({
  label,
  style,
  hideShowMore,
  onShowMore,
  children,
}: FilterGroupProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.root} style={style}>
      {typeof label === 'string' ? (
        <Typography variant="body2" className={classes.label}>
          {label}
        </Typography>
      ) : (
        label
      )}
      {children}
      {onShowMore && !hideShowMore && (
        <WbButton variant="text" label="Show More" onClick={onShowMore} />
      )}
    </Box>
  );
};
